<div class="modal-header">
  <h2 class="modal-title">
    {{ "log.filterPopup.title" | translate }}
  </h2>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeHandler()"
  >
  </button>
</div>

<div class="modal-body">
  <div class="d-flex mb-5">
    <div class="l-title-txt fw-semibold">
      {{ "log.filterPopup.creationDate" | translate }}
    </div>
  </div>

  <div class="row mb-5">
    <div class="col-md-6">
      <label class="label-input">
        {{ "log.filterPopup.startDate" | translate }}
      </label>

      <kendo-datepicker HJSuppress
        [(ngModel)]="startDate"
        class="custom-kendo-control-xl"
        [fillMode]="fillModeOutline"
        [rounded]="roundedLarge"
        #startDateInput
        (click)="!startDateInput.isOpen ? startDateInput.toggle() : null"
        [popupSettings]="{popupClass : 'data-hj-suppress'}"
      >
        <kendo-datepicker-messages
          today="{{ 'calendar.today' | translate }}"
          toggle="{{ 'calendar.toggle' | translate }}"
        >
        </kendo-datepicker-messages>
      </kendo-datepicker>
    </div>

    <div class="col-md-6">
      <label class="label-input">
        {{ "log.filterPopup.endDate" | translate }}
      </label>

      <kendo-datepicker HJSuppress
        [(ngModel)]="endDate"
        class="custom-kendo-control-xl"
        [fillMode]="fillModeOutline"
        [rounded]="roundedLarge"
        #endDateInput
        (click)="!endDateInput.isOpen ? endDateInput.toggle() : null"
        [popupSettings]="{popupClass : 'data-hj-suppress'}"
      >
        <kendo-datepicker-messages
          today="{{ 'calendar.today' | translate }}"
          toggle="{{ 'calendar.toggle' | translate }}"
        >
        </kendo-datepicker-messages>
      </kendo-datepicker>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn link-btn" (click)="resetHandler()">
    <i class="app-icon icon icon-reload icon-lg me-2"></i> 
    {{ "invoice.filterPopup.reset" | translate }}
  </button>

  <button class="btn primary-btn" (click)="applyHandler()">
    {{ "invoice.filterPopup.apply" | translate }}
  </button>
</div>
